import React from "react";
import { Box, Grid } from "@mui/material";
import Login from "./Login";
import useIsMobile from "../../Core/hook/useIsMobile";
import backImg from "../../Images/LoginBc.webp";

const backgroundImg = localStorage.getItem("backgroundImg");

const Auth: React.FC = () => {
  const isMobileRes = useIsMobile();

  return (
    <Box>
      <Grid
        container
        sx={{
          position: "relative",
          height: "100vh",
        }}
      >
        <Box
          component="img"
          src={backgroundImg || backImg}
          alt=""
          sx={{
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        />

        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          sx={{
            position: "relative",
            zIndex: 1,
            height: "100%",
            mr: isMobileRes ? 2 : 20,
            ml: isMobileRes ? 2 : 0,
          }}
        >
          <Grid item lg={4} md={8} sm={12} xs={12}>
            <Login />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Auth;
